export const BREAKPOINTS = {
  SM: 320,
  MD: 768,
  LG: 1280,
  XL: 1440,
} as const;

export const GTM_EVENT_NAMES = {
  headerLogoClick: 'headerLogoClick',
  navClick: 'navClick',
  socialClick: 'socialClick',
  sqAddressSubmitResi: 'sqAddressSubmitResi',
  sqSubmitSuccessResi: 'sqSubmitSuccessResi',
  sqAddressNotAvailable: 'sqAddressNotAvailable',
  findAddressClick: 'findAddressClick',
  sqSubmitExistingUser: 'sqSubmitExistingUser',
  ctaClick: 'ctaClick',
  ctaClickSq: 'ctaClickSq',
  ctaClickSqBanner: 'ctaClickSqBanner',
  selectItem: 'select_item',
  mobilePlanCardSelect: 'mobilePlanCardSelect',
  nbnPlanCardSelect: 'nbnPlanCardSelect',
  appDownloadClick: 'appDownloadClick',
  knowledgeHubLink: 'knowledgeHubLink',
} as const;

export const SCROLLABLE_IDS = {
  MOBILE_PLAN: 'mobile-plan',
  BROADBAND_PLAN: 'broadband-plan',
  FORMS: 'forms',
  ADDRESS_SEARCH: 'address-search',
  SPEED_TEST: 'speed-test',
} as const;

//NAVIGATION
export const PRIMARY_NAV_TYPE = 'Primary Nav Menu';
export const FOOTER_NAV_TYPE = 'Footer Nav Menu';

//SELECT ITEM - NBN/Mobile Add to cart
export const CURRENCY = 'AUD';
export const MOBILE = 'Mobile';
export const NBN = 'NBN';
export const BUNDLE = 'Bundle';
export const NONE = 'None';

//DOWNLOAD APP
export const DOWNLOAD_IOS_TEXT = 'Download on the App Store';
export const DOWNLOAD_ANDROID_TEXT = 'Get it on Google Play';

/**
 * Plan IDs for the new Exeboot, used to check if a user is a legacy user
 */
export const EXEBOOT_BROADBAND_PLAN_IDS = [376];

/**
 * Plan IDs for the new Exeboot mobile plans, used to check if a user is a legacy user
 */
export const EXEBOOT_MOBILE_PLAN_IDS = [377, 378];

// We don't need to point to staging|prod. Using 1 single URL it's fine for now
export const SUPERLOOP_URL = 'https://www.superloop.com';

export const LOCAL_STORAGE = {
  SELECTED_ADDRESS: 'selectedAddress',
};
